import React from "react";
import { Routes, Route } from "react-router-dom";
import Appointments from "../pages/patientportal/clientSchedule/Appointments";
import ProviderAppointmentsPage from "../pages/biportal/providerSchedule/ProviderAppointments";
import AppointmentForm from "../components/forms/providerAppointmentForms/AppointmentForm";
import ReviewProviderDay from "../components/forms/providerAppointmentForms/ReviewProviderDay";
import Login from "./Login/Login";
import Logout from "./Logout/Logout";
import UnverifiedUser from "./UnverifiedUser/UnverifiedUser";
import Main from "./Main/Main";
import PasswordResetSuccessPage from "./PasswordReset/PasswordResetSuccessPage";
import CancelAppointment from "../components/forms/providerAppointmentForms/CancelAppointment";
import EditAppointment from "../components/forms/providerAppointmentForms/EditAppointment";
import EditObserverAppointment from "../components/forms/providerAppointmentForms/EditObserverAppointment";
import PrivateRoute from "./PrivateRoute";
import MsalPrivateRoute from "../MsalPrivateRoute";
import MsalLogin from "./msal/MsalLogin";
import { AppShell, providerNavItems, patientNavItems } from "../components/layout";
import {
  ClientAppointmentFlow,
  ClientReschedule,
  ClientRescheduleConfirm,
  ClientRescheduleBusy,
  ClientRescheduled,
  ClientRescheduleProblem,
  ClientRescheduleNotAvailable,
  ClientCancel,
  ClientCancelDetails,
  ClientCancelReview,
  ClientCancelled,
} from "../components/forms/clientAppointmentForms";
import {
  PatientAvailabiity,
  PatientAvailabilityBuilder,
  PatientAvailabiityDay,
  PateintAvailabilityReview,
  PatientAvailabilityClose,
  PatientAvailabilityStart,
  PatientAvailabilityBuilderReview,
  EditPatientAvailabilityBuilderReview,
  RedirectAvailability,
} from "../components/forms/clientAppointmentForms/PatientAvailability";
import Availability from "../components/clientSupportingComponents/Availability/Availability";
import AllAppointmentsList from "../components/clientSupportingComponents/AllAppointmentsList";
import ClientCancelError from "../components/forms/clientAppointmentForms/CancelAppointments/ClientCancelError";
import ProviderAvailability from "../components/forms/providerAppointmentForms/providerAvailability/ProviderAvailability";
import CollectTeacherSignature from "../pages/biportal/providerSchedule/CollectTeacherSignature";
import ViewTeacherSignature from "../pages/biportal/providerSchedule/ViewTeacherSignature";
import AllDocuments from "../components/clientSupportingComponents/clientDocuments/AllDocuments";
import BenefitsSummaryPage from "../pages/patientportal/benefitsSummary/BenefitsSummaryPage";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Main />} />
    <Route path="/unverified_user" element={<UnverifiedUser />} />
    <Route path="/login" element={<Login />} />
    <Route path="/logout" element={<Logout />} />
    <Route
      path="/password-reset-success"
      element={<PasswordResetSuccessPage />}
    />
    <Route path="/provider" element={<MsalLogin />} />

    {/* Provider routes - wrapped in Sidebar */}
    <Route element={<AppShell navItems={providerNavItems} />}>
      <Route
        path="/add-new-appointment"
        element={<MsalPrivateRoute component={AppointmentForm} />}
      />
      <Route
        path="/cancel-appointment"
        element={<MsalPrivateRoute component={CancelAppointment} />}
      />
      <Route
        path="/providerappointments"
        element={<MsalPrivateRoute component={ProviderAppointmentsPage} />}
      />
      <Route
        path="/edit-appointment"
        element={<MsalPrivateRoute component={EditAppointment} />}
      />
      <Route
        path="/confirm-schedule"
        element={<MsalPrivateRoute component={ReviewProviderDay} />}
      />
      <Route
        path="/edit-observer"
        element={<MsalPrivateRoute component={EditObserverAppointment} />}
      />
      <Route
        path="/availability"
        element={<MsalPrivateRoute component={ProviderAvailability} />}
      />
      <Route
        path="/collect-teacher-signature"
        element={<MsalPrivateRoute component={CollectTeacherSignature} />}
      />
      <Route
        path="/view-teacher-signature"
        element={<MsalPrivateRoute component={ViewTeacherSignature} />}
      />
    </Route>

    {/* Client routes */}
    <Route element={<AppShell navItems={patientNavItems} />}>
      <Route
        path="/appointments"
        element={<PrivateRoute component={Appointments} />}
      />
      <Route
        path="/benefits-summary"
        element={<PrivateRoute component={BenefitsSummaryPage} />}
      />
      <Route
        path="/documents"
        element={<PrivateRoute component={AllDocuments} />}
      />
      <Route
        path="/client-appointments"
        element={<PrivateRoute component={AllAppointmentsList} />}
      />
    </Route>
    <Route path="/avail" element={<PrivateRoute component={Availability} />} />
    {/*Client Availability Flow */}
    <Route
      path="/redirect-availability"
      element={<PrivateRoute component={RedirectAvailability} />}
    />
    <Route
      path="/appointments-availability"
      element={<PrivateRoute component={PatientAvailabiity} />}
    />
    <Route
      path="/appointments-availability-start"
      element={<PrivateRoute component={PatientAvailabilityStart} />}
    />
    <Route
      path="/appointments-availability-builder"
      element={<PrivateRoute component={PatientAvailabilityBuilder} />}
    />
    <Route
      path="/appointments-availability-days"
      element={<PrivateRoute component={PatientAvailabiityDay} />}
    />
    <Route
      path="/appointments-availability-review"
      element={<PrivateRoute component={PateintAvailabilityReview} />}
    />
    <Route
      path="/appointments-availability-builder-review"
      element={<PrivateRoute component={PatientAvailabilityBuilderReview} />}
    />
    <Route
      path="/appointments-availability-close"
      element={<PrivateRoute component={PatientAvailabilityClose} />}
    />
    <Route
      path="/edit-appointments-availiability"
      element={
        <PrivateRoute component={EditPatientAvailabilityBuilderReview} />
      }
    />
    {/*Client Appointment Flow*/}
    <Route
      path="/client-appointment-redirect"
      element={<PrivateRoute component={ClientAppointmentFlow} />}
    />
    {/*Client Reschedule Flow */}
    <Route
      path="/client-reschedule-appointment"
      element={<PrivateRoute component={ClientReschedule} />}
    />
    <Route
      path="/client-reschedule-confirm"
      element={<PrivateRoute component={ClientRescheduleConfirm} />}
    />
    <Route
      path="/client-reschedule-busy"
      element={<PrivateRoute component={ClientRescheduleBusy} />}
    />
    <Route
      path="/client-rescheduled"
      element={<PrivateRoute component={ClientRescheduled} />}
    />
    <Route
      path="/client-reschedule-problem"
      element={<PrivateRoute component={ClientRescheduleProblem} />}
    />
    <Route
      path="/client-reschedule-not-available"
      element={<PrivateRoute component={ClientRescheduleNotAvailable} />}
    />
    {/*Client Cancel Flow */}
    <Route
      path="/client-cancel-details"
      element={<PrivateRoute component={ClientCancelDetails} />}
    />
    <Route
      path="/client-cancel-appointment"
      element={<PrivateRoute component={ClientCancel} />}
    />
    <Route
      path="/client-cancel-review"
      element={<PrivateRoute component={ClientCancelReview} />}
    />
    <Route
      path="/client-cancel-problem"
      element={<PrivateRoute component={ClientCancelError} />}
    />
    <Route
      path="/client-appointment-cancelled"
      element={<PrivateRoute component={ClientCancelled} />}
    />
  </Routes>
);

export default AppRoutes;
